import { Inject, Injectable, Optional } from '@angular/core';
import { SingletonCheckHelper } from '../helpers/singleton-check.helper';
import { TenantCountry } from '../models/enums';
import { TCM_FORM_CONFIG, TCMFormConfig } from '../modules/tcm-form/tcm-form-config';

@Injectable()
export class TcmTenantService {

  get country(): TenantCountry {
    return this.tenantCountry;
  }

  private isInitialized = false;
  private tenantCountry: TenantCountry;

  constructor(@Optional() @Inject(TCM_FORM_CONFIG) protected config: TCMFormConfig) {
    SingletonCheckHelper.ensureSingleton(this);
  }

  init(country: TenantCountry) {
    if (this.isInitialized)
      return;

    this.tenantCountry = country;

    switch (this.tenantCountry) {
      case TenantCountry.GB:
        this.makeSetupUK();
        break;
    }

    this.isInitialized = true;
  }

  private makeSetupUK() {
    const phoneMask = ((displayValue: string) => {

      displayValue = displayValue ? displayValue.replace(' ', '') : displayValue;

      let mask = [];

      if (displayValue.startsWith('02')) {
        // 02# #### ####
        mask = ['0', '2', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('03')) {
        // 03## ### ####
        mask = ['0', '3', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('05')) {
        // 05### ######
        mask = ['0', '5', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('07')) {
        // 07### ######
        mask = ['0', '7', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('0800')) {
        // 0800 ######
        mask = ['0', '8', '0', '0', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('08')) {
        // 08## ### ####
        mask = ['0', '8', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('09')) {
        // 09## ### ####
        mask = ['0', '9', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
      }

      // 01339# #####
      else if (displayValue.startsWith('013397')) {
        // 013397 #####
        mask = ['0', '1', '3', '3', '9', '7', ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('013398')) {
        // 013398 #####
        mask = ['0', '1', '3', '3', '9', '8', ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue == '01339') {
        // 01339# #####
        mask = ['0', '1', '3', '3', '9', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      }

      // 01387# #####
      else if (displayValue.startsWith('013873')) {
        // 013873 #####
        mask = ['0', '1', '3', '8', '7', '3', ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue == '01387') {
        // 01387# #####
        mask = ['0', '1', '3', '8', '7', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      }

      // 01524# #####
      else if (displayValue.startsWith('015242')) {
        // 015242 #####
        mask = ['0', '1', '5', '2', '4', '2', ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue == '01524') {
        // 01524# #####
        mask = ['0', '1', '5', '2', '4', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      }

      // 01539# #####
      else if (displayValue.startsWith('015394')) {
        // 015394 #####
        mask = ['0', '1', '5', '3', '9', '4', ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('015395')) {
        // 015395 #####
        mask = ['0', '1', '5', '3', '9', '5', ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('015396')) {
        // 015396 #####
        mask = ['0', '1', '5', '3', '9', '6', ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue == '01539') {
        // 01539# #####
        mask = ['0', '1', '5', '3', '9', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      }

      // 01697# #####
      else if (displayValue.startsWith('016973')) {
        // 016973 #####
        mask = ['0', '1', '6', '9', '7', '3', ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('016974')) {
        // 016974 #####
        mask = ['0', '1', '6', '9', '7', '4', ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('016977')) {
        // 016977 ####
        // 016977 #####
        mask = ['0', '1', '6', '9', '7', '7', ' ', /\d/, /\d/, /\d/, /\d/, /[\d]?/];
      } else if (displayValue == '01697') {
        // 016977 ####
        // 016977 #####
        mask = ['0', '1', '6', '9', '7', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /[\d]?/];
      }

      // 01768# #####
      else if (displayValue.startsWith('017683')) {
        // 017683 #####
        mask = ['0', '1', '7', '6', '8', '3', ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('017684')) {
        // 017684 #####
        mask = ['0', '1', '7', '6', '8', '4', ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('017687')) {
        // 017687 #####
        mask = ['0', '1', '7', '6', '8', '7', ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue == '01768') {
        // 017687 #####
        mask = ['0', '1', '7', '6', '8', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      }

      // 01946# #####
      else if (displayValue.startsWith('019467')) {
        // 019467 #####
        mask = ['0', '1', '9', '4', '6', '7', ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue == '01946') {
        // 01946# #####
        mask = ['0', '1', '9', '4', '6', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      }

      // 01975# #####
      else if (displayValue.startsWith('019755')) {
        // 019755 #####
        mask = ['0', '1', '9', '7', '5', '5', ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('019756')) {
        // 019756 #####
        mask = ['0', '1', '9', '7', '5', '6', ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue == '01975') {
        // 01975# #####
        mask = ['0', '1', '9', '7', '5', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
      }

      else if (displayValue.startsWith('011')) {
        // 011# ### ####
        mask = ['0', '1', '1', /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('01') && displayValue.length >= 4 && displayValue[3] == '1') {
        // 01#1 ### ####
        mask = ['0', '1', /\d/, '1', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
      } else if (displayValue.startsWith('01')) {
        // 01### #####
        // 01### ######
        mask = ['0', '1', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /[\d]?/];
      } else {
        mask = ['0', /[1,2,3,5,7,8,9]/, /\d/, /[\d, ]/, /[\d, ]/, /[\d, ]/, /[\d, ]/, /[\d, ]/, /[\d, ]/, /[\d, ]/, /[\d, ]/, /[\d, ]/, /[\d, ]/];
      }

      return mask;
    }) as any;

    this.config.phoneMask = phoneMask;
  }
}